import Dot from '@sats-group/icons/16/dot';
import Text from '@sats-group/ui-lib/react/text';
import cn from 'classnames';
import React from 'react';
import type { Indicator as Props } from './indicator.types';

const Indicator: React.FC<Props> = ({ text, theme }) => (
  <div className={cn('indicator', `indicator--${theme}`)}>
    <Dot />
    <Text size={Text.sizes.small}>{text}</Text>
  </div>
);

export default Indicator;
